import { Button } from 'semantic-ui-react'
import { t } from 'shared'
import { LogoUploadTriggerProps } from './types'
import { PhotoIcon } from '@heroicons/react/24/outline'

export const uploadButtonFactory = (uploaded?: boolean, photoLabel = '') => {
  const UploadTrigger = ({ content: _, primary: __, ...props }: LogoUploadTriggerProps) => {
    let content = t('misc.upload', { thing: photoLabel || t('misc.image') })

    if (uploaded) {
      content = t('misc.change_image')
    } else if (photoLabel.toLowerCase() === 'bild') {
      content = t('misc.image_upload')
    }

    return (
      <Button
        fluid={!uploaded}
        primary
        basic={uploaded}
        content={
          <div className="flex flex-row gap-2 items-center justify-center">
            <PhotoIcon className="w-6 h-6" />
            {content}
          </div>
        }
        {...props}
      />
    )
  }
  return UploadTrigger
}
